import { Navigate } from 'react-router-dom';
import { useFirstAccessibleRoute } from 'hooks/useFirstAccessibleRoute';

/**
 * Redirects to the user's first accessible route based on their permissions.
 * Used for the root "/" path to ensure users land on a page they can access.
 */
const DynamicHomeRedirect = () => {
  const { href } = useFirstAccessibleRoute();
  return <Navigate to={href} replace />;
};

export default DynamicHomeRedirect;
